export default __webpack_public_path__ + "static/media/surfaceTreatment.cde8db30.webp";